import React, { Component } from 'react';

import Values from './Values'

class BelowLanding extends Component {
  constructor(props) {
    super(props)
    this.state = { Values: null }
  }

  render() {
    return (
      <div className="below-landing">
        <Values />
      </div>
    );
  }
}

export default BelowLanding;



// WEBPACK FOOTER //
// ./src/components/BelowLanding.jsx